import simpleParallax from 'simple-parallax-js';

export default function parallax()
{
    if (window.screen.width >= 1400) {
        const elements = document.querySelectorAll('.parallax');
        const elementsDelay = document.querySelectorAll('.parallax__delay');

        // eslint-disable-next-line no-new,new-cap
        new simpleParallax(elements, {
            overflow: true,
        });

        // eslint-disable-next-line no-new,new-cap
        new simpleParallax(elementsDelay, {
            delay: 0.8,
            overflow: true,
        });
    }
}
